// The MIT License (MIT)
//
// Copyright (c) 2024-2025 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
export default `<svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        class="svg-inline--fa-solid fa-sort fa-w-10"
        data-icon="sort"
        data-prefix="fas"
        viewBox="0 0 16 16"
        width="1em"
        height="1em"
      >
        <path
          d="M9.286 12.783V3.217c0-.86 1.041-1.29 1.648-.683l4.783 4.783a.96.96 0 0 1 0 1.362l-4.783 4.787c-.607.607-1.648.177-1.648-.683M5.066 2.534.283 7.317a.96.96 0 0 0 0 1.362l4.783 4.787c.607.607 1.648.177 1.648-.683V3.217c0-.86-1.041-1.29-1.648-.683"
          style="fill: currentColor; stroke-width: 0.04019091"
        /></svg>`;
//# sourceMappingURL=swipe_svg.js.map